export default "__VITE_ASSET__e8IVdGFP__"